"use client";

// Mobil: yüzen "Harita" butonu → tam ekran arama-sonuçları haritası.
// Overlay header'ı sonuç sayfasıyla aynı: geri (haritayı kapat) + arama barı.

import { useState } from "react";
import { Map as MapIcon, ChevronLeft } from "lucide-react";
import { SearchBar } from "@/components/common/search-bar";
import { SearchResultsMap, type MapListing } from "./search-results-map";

export function ResultsMapMobile({ listings }: { listings: MapListing[] }) {
  const [open, setOpen] = useState(false);

  // Konumlu ilan yoksa harita butonu gösterme.
  if (listings.length === 0) return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="bg-primary fixed bottom-28 left-1/2 z-40 flex -translate-x-1/2 items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold text-white shadow-lg md:hidden"
        >
          <MapIcon className="h-4 w-4" />
          Harita
        </button>
      )}

      {open && (
        <div className="fixed inset-0 z-50 flex flex-col bg-white md:hidden">
          {/* Header — sonuç sayfası gibi: geri (haritayı kapat) + arama barı */}
          <div className="shrink-0 border-b bg-white">
            <div className="flex items-center gap-3 p-4">
              <button
                onClick={() => setOpen(false)}
                className="shrink-0 p-1"
                aria-label="Listeye dön"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
              <div className="flex-1">
                <SearchBar />
              </div>
            </div>
          </div>

          {/* isolate → Leaflet'in kaçan z-1000 zoom kontrolü haritanın kendi
              stacking context'inde kalır; header'daki arama dropdown'ının üstüne binmez. */}
          <div className="isolate flex-1">
            <SearchResultsMap listings={listings} />
          </div>
        </div>
      )}
    </>
  );
}
